module.exports = {"370306001":"丝绸路街道","370306002":"大街街道","370306003":"青年路街道","370306004":"永安街道","370306005":"城北路街道","370306100":"北郊镇","370306101":"南郊镇","370306102":"王村镇","370306103":"萌水镇","370306104":"商家镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370306.json
// module id = 1497
// module chunks = 0